import Cookies from 'js-cookie';

export function getFBCookieValue(fb_cookie_key) {
  const fb_cookie_value = Cookies.get(fb_cookie_key);

  if (!fb_cookie_value || fb_cookie_value === '') {
    return '';
  }

  let urlString = '';

  urlString += `&${fb_cookie_key.replace('_', '')}=${fb_cookie_value}`;

  return urlString;
}
